<template>
  <div>
    <div class="cropper-content">
      <!-- 剪裁框 -->
      <div class="cropper">
        <img ref="image" :src="imgFile" alt="" />
      </div>
      <!-- 预览框 -->
      <div class="show-preview">
        <div class="preview before"></div>
      </div>
    </div>
    <div class="footer-btn">
      <!-- 缩放旋转按钮 -->
      <div class="scope-btn">
        <el-tooltip class="item" effect="dark" content="缩小" placement="top">
          <el-button class="el-icon-zoom-out" @click="cropperzoom(-0.05)" />
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="放大" placement="top">
          <el-button class="el-icon-zoom-in" @click="cropperzoom(0.05)" />
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="dark"
          content="逆时针旋转"
          placement="top"
        >
          <el-button class="el-icon-refresh-left" @click="cropperRotate(-90)" />
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="dark"
          content="顺时针旋转"
          placement="top"
        >
          <el-button class="el-icon-refresh-right" @click="cropperRotate(90)" />
        </el-tooltip>
      </div>

      <!-- 确认上传按钮 -->
      <div class="upload-btn">
        <!-- <el-button type="primary" @click="uploadImg('blob')">上传</el-button> -->
        <el-button
          v-if="autoCropWidth && autoCropHeight"
          @click="setRate(setRatioFlag)"
          v-text="setRatioFlag ? '自由裁切' : '原图比例'"
        ></el-button>
        <el-button @click="closeCropper">取消</el-button>
        <el-button type="primary" :disabled="isDisabled" @click="sureSave()">
          确定
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
//   按钮图标需要重新配置
import Cropper from 'cropperjs'
import 'cropperjs/dist/cropper.css'
import { getImgFileType } from '@utils/utils'

export default {
  name: 'VueCropper',
  props: {
    imgFile: {
      type: String,
      default: '',
    },
    autoCropWidth: {
      type: Number,
      default: 0,
    },
    autoCropHeight: {
      type: Number,
      default: 0,
    },
    uploadImageType: {
      type: String,
      default: 'all',
    },
    setRatioFlag: {
      type: Boolean,
      default: false, // false:自由裁切；true:按原比例裁切
    },
  },
  data() {
    return {
      myCropper: null,
      afterImg: '',
      ScaleX: 1,
      ScaleY: 1,
      fixed: false,
      fixedBox: false,
      inputRotate: 0,
      isDisabled: false,
      imgFileType: 'image/png', //默认是生成 png, 可以改变在 init里面
    }
  },
  computed: {},
  watch: {
    imgFile: {
      handler(newVal, oldVal) {
        if (this.myCropper) {
          this.myCropper.reset()
          this.myCropper.replace(newVal)
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    closeCropper() {
      this.$emit('closeCropper')
    },
    handleChangeRotate(value) {
      this.cropperrotateTo(value)
    },
    init() {
      this.myCropper = new Cropper(this.$refs.image, {
        viewMode: 1,
        dragMode: 'move',
        // initialAspectRatio: 1,
        preview: '.before',
        background: false,
        autoCropArea: 1,
        zoomOnWheel: true,
        aspectRatio: this.setRatioFlag
          ? this.autoCropWidth / this.autoCropHeight
          : 0,
        // movable :true,
        // rotatable :true
      })
      // console.debug('imgFile:', this.imgFile)
      this.imgFileType = getImgFileType(this.imgFile)
    },

    setRate(flag) {
      this.$emit('changeSetRatioFlagEvent', !flag)
      if (!flag) {
        this.myCropper.setAspectRatio(this.autoCropWidth / this.autoCropHeight)
      } else {
        this.myCropper.setAspectRatio(0)
      }
    },
    // 裁剪
    // uploadImgs() {
    //   this.afterImg = this.myCropper
    //     .getCroppedCanvas({
    //       imageSmoothingQuality: 'high', // [high, medium, low]
    //     })
    //     .toDataURL('image/png') //[image/jpeg|image/png]
    //   this.$emit('getCrop', this.afterImg)
    // },
    sureSave() {
      this.afterImg = this.myCropper
        .getCroppedCanvas({
          imageSmoothingQuality: 'high', // [high, medium, low]
        })
        .toDataURL(this.imgFileType)
      let data = ''
      if (this.uploadImageType === 'blob') {
        data = {
          data: this.base64ToBlob(this.afterImg),
          setRatioFlag: this.setRatioFlag,
        }
      } else if (this.uploadImageType === 'base64') {
        data = {
          data: this.afterImg,
          setRatioFlag: this.setRatioFlag,
        }
      } else if (this.uploadImageType === 'all') {
        data = {
          base64: this.afterImg,
          blob: this.base64ToBlob(this.afterImg),
          setRatioFlag: this.setRatioFlag, //是否按原图比例裁切，true:原比例切图，false:自由裁切
        }
      } else {
        data = {
          data: '',
          setRatioFlag: this.setRatioFlag,
          tipText: '请选择传输哪种格式的图片',
        }
      }
      this.$emit('upload', data)
    },
    base64ToBlob(code) {
      console.debug('base64ToBlob:', code)
      const parts = code.split(';base64,')
      const contentType = parts[0].split(':')[1]
      const base64Regex = /^[A-Za-z0-9+/]+={0,2}$/
      if (!base64Regex.test(parts[1])) {
        throw new Error('The string to be decoded is not correctly encoded.')
      }
      console.debug('base64ToBlob:', parts[1].length)
      const raw = window.atob(parts[1])
      const rawLength = raw.length

      const uInt8Array = new Uint8Array(rawLength)

      for (let i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i)
      }
      return new Blob([uInt8Array], {
        type: contentType,
      })
    },
    // 缩放
    cropperzoom(val) {
      this.myCropper.zoom(val)
    },
    // 重置
    cropperReset() {
      this.myCropper.reset()
      this.ScaleX = 1
      this.ScaleY = 1
    },
    // 移动
    croppermove(val1, val2) {
      this.myCropper.move(val1, val2)
    },
    // 旋转
    cropperRotate(val) {
      this.myCropper.rotate(val)
    },
    // 绝对角度旋转
    cropperrotateTo(val) {
      this.myCropper.rotateTo(val)
    },
    // X轴翻转
    cropperScaleX() {
      this.ScaleX = -this.ScaleX
      if (
        this.myCropper.getImageData().rotate === -90 ||
        this.myCropper.getImageData().rotate === 90
      ) {
        this.myCropper.scaleY(this.ScaleX)
      } else {
        this.myCropper.scaleX(this.ScaleX)
      }
    },
    // y轴翻转
    cropperScaleY() {
      this.ScaleY = -this.ScaleY
      if (
        this.myCropper.getImageData().rotate === -90 ||
        this.myCropper.getImageData().rotate === 90
      ) {
        this.myCropper.scaleX(this.ScaleY)
      } else {
        this.myCropper.scaleY(this.ScaleY)
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.cropper {
  border: 1px solid #fff;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAA3NCSVQICAjb4U/gAAAABlBMVEXMzMz////TjRV2AAAACXBIWXMAAArrAAAK6wGCiw1aAAAAHHRFWHRTb2Z0d2FyZQBBZG9iZSBGaXJld29ya3MgQ1M26LyyjAAAABFJREFUCJlj+M/AgBVhF/0PAH6/D/HkDxOGAAAAAElFTkSuQmCC);
  img {
    width: 100%;
    opacity: 0;
  }
}
.cropper-content {
  display: flex;
  display: -webkit-flex;
  justify-content: flex-end;
  -webkit-justify-content: flex-end;
  padding-left: 1.736vw;
}
.cropper-content .cropper {
  width: 50%;
  height: 27.78vw;
  overflow: hidden;
}
.cropper-content .show-preview {
  flex: 1;
  -webkit-flex: 1;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  align-items: center;
  -webkit-justify-content: center;
  overflow: hidden;
  /* border: 1px solid #cccccc; */
  background: #cccccc;
  margin: 0 1.736vw;
}
.preview {
  overflow: hidden;
  border: 1px solid #468ac8;
  background: #cccccc;
}
.footer-btn {
  margin-top: 2.083vw;
  padding-left: 1.736vw;
  display: flex;
  display: -webkit-flex;
  justify-content: flex-end;
  -webkit-justify-content: flex-end;
}
.footer-btn .scope-btn {
  width: 18.05vw;
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  -webkit-justify-content: space-between;
}
.footer-btn .scope-btn span {
  display: inline-block;
  padding: 0.694vw;
  box-shadow: 0 2px 0.833vw 0 rgba(0, 0, 0, 0.1);
  border-radius: 0.347vw;
  background: #fff;
  cursor: pointer;
}
.footer-btn .scope-btn span i {
  font-size: 2.083vw;
  color: var(--titleText);
}
.footer-btn .upload-btn {
  flex: 1;
  -webkit-flex: 1;
  display: flex;
  display: -webkit-flex;
  justify-content: flex-end;
  -webkit-justify-content: flex-end;
  margin-right: 1.736vw;
}
.footer-btn .btn {
  outline: none;
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  /* -webkit-appearance: none; */
  text-align: center;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  outline: 0;
  margin: 0;
  -webkit-transition: 0.1s;
  transition: 0.1s;
  font-weight: 500;
  padding: 0.556vw 1.041vw;
  font-size: 0.833vw;
  border-radius: 0.208;
  color: #fff;
  background-color: var(--mixtmt_sccessColor);
  border-color: var(--mixtmt_sccessColor);
}
.solide {
  margin-left: 1.736vw;
  width: 13.88vw;
}
.before {
  width: 100%;
  height: 100%;
  overflow: hidden;
  /* 这个属性可以得到想要的效果 */
}
</style>
<style lang="scss">
.cropperPop {
  .el-button {
    height: 2.22vw;
    padding: 0.556vw 1.042vw;
    font-size: 0.972vw;
    color: var(--mixtmt_greyColor2);
    /* color: var(--el-button-text-color);
      font-weight: var(--el-button-font-weight);
      background-color: var(--el-button-bg-color);
      border: var(--el-border);
      border-color: var(--el-button-border-color);
      font-size: var(--el-font-size-base);
      border-radius: var(--el-border-radius-base); */
  }
  .el-button--primary {
    color: var(--mixtmt_whiteColor);
    background-color: var(--mixtmt_mainColor6);
    border-color: var(--mixtmt_mainColor6);
  }
  .el-button:focus,
  .el-button:hover {
    color: var(--mixtmt_mainColor8);
    border-color: var(--mixtmt_mainColor8);
    background-color: var(--mixtmt_whiteColor);
  }

  .el-button--primary.el-button:focus,
  .el-button--primary.el-button:hover {
    color: var(--mixtmt_whiteColor);
    border-color: var(--mixtmt_mainColor8);
    background-color: var(--mixtmt_mainColor8);
  }
}
</style>
